module.exports = __webpack_public_path__ + "img/sepa.3b8d3fa5.svg";